module.exports = __webpack_public_path__ + "img/outer_temp_device.4da78153.png";